// @flow

import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import alertReducer from 'store/reducers/alert/reducer';
import availableTimesReducer from 'store/reducers/availableTimes/reducer';
import dealerSettingsReducer from 'store/reducers/dealerSettings/reducer';
import firstAvailableTimeSlotReducer from 'store/reducers/firstAvailableTimeSlot/reducer';
import queryParamsReducer from 'store/reducers/queryParams/reducer';
import localizationStringReducer from 'store/reducers/localizationString/reducer';
import tokenIdReducer from 'store/reducers/tokenId/reducer';
import appointmentReducer from 'store/reducers/appointment/reducer';
import apptOptionsReducer from 'store/reducers/apptOptions/reducer';
import ajaxCallReducer from 'store/reducers/ajaxCall/reducer';
import yearsReducer from 'store/reducers/years/reducer';
import modelsReducer from 'store/reducers/models/reducer';
import declinedReducer from 'store/reducers/declined/reducer';
import maintenanceReducer from 'store/reducers/maintenance/reducer';
import repairReducer from 'store/reducers/repair/reducer';
import globalRepairReducer from 'store/reducers/globalRepair/reducer';
import dealerDataReducer from 'store/reducers/dealerData/reducer';
import dealerLocaleReducer from 'store/reducers/dealerLocale/reducer';
import userInteractionsReducer from 'store/reducers/userInteractions/reducer';
import navigationReducer from 'store/reducers/navigation/reducer';
import packagesReducer from 'store/reducers/packages/reducer';
import customerVehiclesReducer from 'store/reducers/customerVehicles/reducer';
import trimReducer from 'store/reducers/trims/reducer';
import deeplinkReducer from 'store/reducers/deeplink/reducer';
import loginReducer from 'store/reducers/login/reducer';
import marketingReducer from 'store/reducers/marketing/reducer';
import recallReducer from 'store/reducers/recall/reducer';
import deferredReducer from 'store/reducers/deferred/reducer';
import uiReducer from './reducers/ui/reducer';
import userReducer from './reducers/user/reducer';
import errorsReducer from './reducers/errors/reducer';
import statesReducer from './reducers/states/reducer';
import promotionReducer from './reducers/promotions/reducer';
import statusTrackerReducer from './reducers/statusTracker/reducer';
import selfCheckInReducer from './reducers/selfCheckIn/reducer';
import quoteApptReducer from './reducers/quoteAppt/reducer';
import optimizelyABTestReducer from './reducers/optimizelyABTest/reducer';
import scriptsReducer from './reducers/scripts/reducer';

const rootReducer = {
  // vendor
  router: routerReducer,
  form: formReducer,

  // own
  ajaxCall: ajaxCallReducer,
  alert: alertReducer,
  userInteractions: userInteractionsReducer,
  appointment: appointmentReducer,
  apptOptions: apptOptionsReducer,
  availableTimes: availableTimesReducer,
  customerVehicles: customerVehiclesReducer,
  dealerLocale: dealerLocaleReducer,
  dealerData: dealerDataReducer,
  dealerSettings: dealerSettingsReducer,
  declined: declinedReducer,
  deeplink: deeplinkReducer,
  deferred: deferredReducer,
  errors: errorsReducer,
  firstAvailableTimeSlot: firstAvailableTimeSlotReducer,
  localizationString: localizationStringReducer,
  login: loginReducer,
  maintenance: maintenanceReducer,
  marketing: marketingReducer,
  models: modelsReducer,
  navigation: navigationReducer,
  packages: packagesReducer,
  queryParams: queryParamsReducer,
  recall: recallReducer,
  repair: repairReducer,
  globalRepair: globalRepairReducer,
  tokenId: tokenIdReducer,
  trims: trimReducer,
  years: yearsReducer,
  ui: uiReducer,
  user: userReducer,
  states: statesReducer,
  promotion: promotionReducer,
  statusTracker: statusTrackerReducer,
  selfCheckIn: selfCheckInReducer,
  quoteAppt: quoteApptReducer,
  optimizelyABTest: optimizelyABTestReducer,
  scripts: scriptsReducer
};

export type Reducers = typeof rootReducer;

export default combineReducers(rootReducer);



// WEBPACK FOOTER //
// ./src/store/rootReducer.js